import { CommonModule } from '@angular/common'
import { ChangeDetectionStrategy, Component, input, signal } from '@angular/core'
import { MatIcon } from '@angular/material/icon'
import {
  type GroupNode,
  NgDiagramGroupHighlightedDirective,
  type NgDiagramGroupNodeTemplate,
  NgDiagramNodeResizeAdornmentComponent,
  NgDiagramNodeSelectedDirective,
  NgDiagramPortComponent,
} from 'ng-diagram'

export interface AttachmentNodeData {
  images: { name: string; dataUrl: string }[]
}

@Component({
  selector: 'ddc-canvas-node-attachment',
  imports: [
    NgDiagramPortComponent,
    NgDiagramNodeSelectedDirective,
    NgDiagramGroupHighlightedDirective,
    CommonModule,
    NgDiagramNodeResizeAdornmentComponent,
    MatIcon,
  ],
  templateUrl: './attachment-node.component.html',
  styleUrls: ['./attachment-node.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.ng-diagram-port-hoverable]': 'true',
  },
})
export class CanvasAttachmentNodeComponent implements NgDiagramGroupNodeTemplate<AttachmentNodeData> {
  node = input.required<GroupNode<AttachmentNodeData>>()
  title = signal<string>('Attachment')
  icon = signal<string>('attachment')

  get attachmentCount(): number {
    return this.node()?.data?.images?.length ?? 0
  }

  get attachmentLabel(): string {
    const count = this.attachmentCount
    if (count === 0) return 'No attachments'
    return `${count} attachment${count > 1 ? 's' : ''}`
  }
}
